
<div class="setConfigurator">
  <v-stepper v-model="step" vertical :non-linear="true" class="configurationStepper">
    <v-stepper-step v-if="personSelectionNeeded"
                    :complete="step > personSelectionStep"
                    :step="personSelectionStep"
                    edit-icon="check"
                    editable
    >{{ $t("CONFIGURATOR_CHOOSE_PERSON") }}
      <small>{{ $t("CONFIGURATOR_CHOOSE_PERSON_HINT") }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="personSelectionNeeded" :step="personSelectionStep">
      <PersonSelector v-model="personIndex" :persons="eligiblePersons" @select="step++"/>
    </v-stepper-content>

    <v-stepper-step v-if="configurationTypeSelectionNeeded"
                    :complete="step > configurationTypeSelectionStep"
                    :step="configurationTypeSelectionStep"
                    edit-icon="check"
                    editable
    >{{ $t("CONFIGURATOR_CHOOSE_MODE") }}
    </v-stepper-step>
    <v-stepper-content v-if="needsToChooseDetailedConfiguration" :step="configurationTypeSelectionStep">
      <ConfigurationModeSelector v-model="configurationMode"
                                 :product="product"
                                 ref="modeSelector"
                                 @select="nextStep"/>
    </v-stepper-content>

    <v-stepper-step
        :complete="step > imageSelectionStep"
        :step="imageSelectionStep"
        edit-icon="check"
    >{{ $t("CONFIGURATOR_CHOOSE_IMAGES") }}
    </v-stepper-step>
    <v-stepper-content :step="imageSelectionStep" class="imageStepperContent">
      <MultipleRequirementsSelector v-if="step === imageSelectionStep"
                                    v-model="imageSelection"
                                    class="multipleRequirementImageSelector"
                                    :requirements="imageRequirements"
                                    :person="person"
                                    :detailed-configuration="isDetailedConfiguration"
                                    ref="imageSelector"/>
    </v-stepper-content>
  </v-stepper>
  <v-row class="actionButtons" justify="center">
    <v-col v-if="addedToBasket" cols="auto">
      <v-btn class="actionButton" color="primary" @click="goToStep(3)">
        <v-icon>arrow_back</v-icon>
        {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
      </v-btn>
    </v-col>
    <v-col cols="auto">
      <v-btn v-if="configurationComplete" color="primary" class="actionButton" @click="addToBasket">
        <v-icon>add_shopping_cart</v-icon>
        {{ $t("BUTTON_ADD_TO_BASKET") }}
      </v-btn>
      <v-btn v-else-if="mayShowContinueButton" color="primary" class="actionButton" @click="continueImageSelection">
        {{ $t("BUTTON_CONTINUE") }}
      </v-btn>
    </v-col>
    <v-col v-if="addedToBasket" cols="auto">
      <v-btn class="actionButton" color="primary" @click="configureAgain">
        <v-icon>replay</v-icon>
        {{ $t("BUTTON_CONFIGURE_AGAIN") }}
      </v-btn>
    </v-col>
  </v-row>
</div>
